(function(){
  function clean(value){return String(value||'').trim().toLowerCase().replace(/\s+/g,' ')}
  function money(cents){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(Number(cents||0)/100)}

  function init(root){
    if(!root||root.dataset.lmuV12Controller==='true')return;

    var form=root.querySelector('[data-product-form]');
    var source=root.querySelector('[data-product-variants]')||document.querySelector('[data-product-variants]');
    var hero=root.querySelector('[data-main-product-image]');
    var mainMedia=root.querySelector('.lmu-pdp-v10__main-media');
    if(!form||!source||!hero)return;

    var variants=[];
    try{variants=JSON.parse(source.textContent||'[]')}catch(error){variants=[]}
    if(!variants.length)return;

    root.dataset.lmuV12Controller='true';

    var selects=Array.from(form.querySelectorAll('select[data-option-index]'));
    var variantId=form.querySelector('[data-variant-id]');
    var addButton=form.querySelector('[data-add-button]');
    var price=root.querySelector('[data-product-price]');
    var netPrice=root.querySelector('[data-product-price-net]');
    var code=root.querySelector('[data-product-code]');
    var thumbs=Array.from(root.querySelectorAll('[data-product-thumb]'));
    var originalSwatches=Array.from(form.querySelectorAll('.lmu-pdp-v10__field--colour [data-colour-swatch]'));
    var colourIndex=-1;
    if(originalSwatches.length){
      var initialColourIndex=originalSwatches[0].dataset.optionIndex;
      if(initialColourIndex===undefined)initialColourIndex=originalSwatches[0].dataset.colourOptionIndex;
      var parsedColourIndex=Number(initialColourIndex);
      if(Number.isFinite(parsedColourIndex))colourIndex=parsedColourIndex;
    }
    var changing=false;
    var customerChangedMedia=false;

    var galleryTemplate=document.querySelector('[data-lmu-gallery-master-thumbs]');
    var lifestyleThumb=galleryTemplate&&galleryTemplate.content?galleryTemplate.content.querySelector('[data-gallery-type="lifestyle"][data-media-type="image"]'):null;
    var initialHero={
      src:lifestyleThumb&&lifestyleThumb.dataset.image?lifestyleThumb.dataset.image:(hero.currentSrc||hero.src||''),
      alt:lifestyleThumb&&lifestyleThumb.dataset.alt?lifestyleThumb.dataset.alt:(hero.alt||''),
      id:lifestyleThumb&&lifestyleThumb.dataset.imageId?lifestyleThumb.dataset.imageId:''
    };

    function liveThumbs(){return Array.from(root.querySelectorAll('[data-product-thumb]'))}

    function resetZoom(){
      hero.style.removeProperty('transform');
      hero.style.setProperty('transform-origin','50% 50%','important');
    }

    function setHero(src,alt,imageId){
      if(!src)return;
      resetZoom();
      hero.removeAttribute('srcset');
      hero.removeAttribute('sizes');
      hero.src=src;
      if(alt)hero.alt=alt;
      var base=String(src).split('?')[0];
      liveThumbs().forEach(function(thumb){
        var byId=imageId&&String(thumb.dataset.imageId||'')===String(imageId);
        var byUrl=String(thumb.dataset.image||'').split('?')[0]===base;
        thumb.classList.toggle('is-active',!!(byId||byUrl));
      });
    }

    function restoreOpeningHero(){
      if(customerChangedMedia||!initialHero.src)return;
      setHero(initialHero.src,initialHero.alt,initialHero.id);
    }

    function scheduleOpeningHeroRestore(){
      [0,40,120,300,650,1000].forEach(function(delay){setTimeout(restoreOpeningHero,delay)});
    }

    function initHoverZoom(){
      if(!mainMedia||!window.matchMedia||!window.matchMedia('(hover: hover) and (pointer: fine)').matches)return;
      if(mainMedia.dataset.lmuHoverZoom==='true')return;
      mainMedia.dataset.lmuHoverZoom='true';
      mainMedia.style.cursor='zoom-in';
      hero.style.setProperty('transition','transform 120ms ease-out','important');
      hero.style.setProperty('will-change','transform');

      function ignoreTarget(target){
        return !!(target&&target.closest&&target.closest('.lmu-gallery-main-nav,.lmu-gallery-counter,.lmu-gallery-colour,.lmu-pdp-v10__badge,.lmu-gallery-video-stage'));
      }

      function zoomAt(event){
        if(hero.style.display==='none'||ignoreTarget(event.target)){resetZoom();return}
        var rect=mainMedia.getBoundingClientRect();
        if(!rect.width||!rect.height)return;
        var x=Math.max(0,Math.min(100,((event.clientX-rect.left)/rect.width)*100));
        var y=Math.max(0,Math.min(100,((event.clientY-rect.top)/rect.height)*100));
        hero.style.setProperty('transform-origin',x+'% '+y+'%','important');
        hero.style.setProperty('transform','scale(2.1)','important');
      }

      mainMedia.addEventListener('pointerenter',zoomAt);
      mainMedia.addEventListener('pointermove',zoomAt);
      mainMedia.addEventListener('pointerleave',resetZoom);
      mainMedia.addEventListener('pointerdown',resetZoom,true);
    }

    root.addEventListener('pointerdown',function(event){
      var target=event.target.closest&&event.target.closest('[data-product-thumb],[data-colour-swatch],[data-mobile-colour-swatch],.lmu-gallery-main-nav,.lmu-gallery-rail__button,.lmu-pdp-v10__main-media');
      if(target)customerChangedMedia=true;
    },true);

    function currentValues(){
      var values=[];
      selects.forEach(function(select){values[Number(select.dataset.optionIndex)]=select.value});
      return values;
    }

    function findVariant(values){
      return variants.find(function(variant){
        return variant.options&&variant.options.every(function(option,index){return clean(option)===clean(values[index])});
      })||null;
    }

    function imageForVariant(variant){
      if(variant&&variant.featured_image&&variant.featured_image.src){
        return {src:String(variant.featured_image.src).split('?')[0]+'?width=1600',alt:variant.featured_image.alt||'',id:variant.featured_image.id||''};
      }
      if(colourIndex<0||!variant||!variant.options)return null;
      var colour=clean(variant.options[colourIndex]);
      var thumb=liveThumbs().find(function(item){return clean(item.dataset.alt||'').includes(colour)});
      return thumb?{src:thumb.dataset.image,alt:thumb.dataset.alt||'',id:thumb.dataset.imageId||''}:null;
    }

    function syncSwatches(value){
      root.querySelectorAll('[data-colour-swatch]').forEach(function(button){
        var rawIndex=button.dataset.optionIndex;
        if(rawIndex===undefined)rawIndex=button.dataset.colourOptionIndex;
        if(Number(rawIndex)!==colourIndex)return;
        var selected=clean(button.dataset.value)===clean(value);
        button.classList.toggle('is-selected',selected);
        button.setAttribute('aria-pressed',selected?'true':'false');
      });
    }

    function syncVariant(variant,updateHero){
      if(!variant)return;
      if(variantId)variantId.value=variant.id;
      if(addButton){
        addButton.disabled=!variant.available;
        addButton.textContent=variant.available?'Add to basket':'Currently unavailable';
      }
      if(price)price.textContent=money(Math.round(Number(variant.price)*1.2));
      if(netPrice)netPrice.textContent=money(variant.price);
      if(code)code.textContent=variant.sku||'';
      var image=imageForVariant(variant);
      if(updateHero!==false&&image)setHero(image.src,image.alt,image.id);
      if(colourIndex>=0&&variant.options)syncSwatches(variant.options[colourIndex]);
      try{history.replaceState({},'',location.pathname+'?variant='+variant.id)}catch(error){}
    }

    function resolveForColour(actual){
      var values=currentValues();
      values[colourIndex]=actual;
      var exact=findVariant(values);
      if(exact)return exact;
      return variants.find(function(variant){
        return variant.available&&variant.options&&clean(variant.options[colourIndex])===clean(actual);
      })||variants.find(function(variant){
        return variant.options&&clean(variant.options[colourIndex])===clean(actual);
      })||null;
    }

    function chooseColour(swatch){
      if(colourIndex<0)return;
      customerChangedMedia=true;
      resetZoom();
      var buttonIndex=Number(swatch.dataset.optionIndex);
      var index=Number.isFinite(buttonIndex)?buttonIndex:colourIndex;
      var colourSelect=form.querySelector('select[data-option-index="'+index+'"]');
      if(!colourSelect)return;

      var wanted=clean(swatch.dataset.value||swatch.title||swatch.textContent);
      var option=Array.from(colourSelect.options).find(function(item){return clean(item.value)===wanted});
      if(!option)return;

      var actual=option.value;
      var variant=resolveForColour(actual);
      if(!variant)return;

      changing=true;
      selects.forEach(function(select){
        var optionIndex=Number(select.dataset.optionIndex);
        if(variant.options&&variant.options[optionIndex]!=null)select.value=variant.options[optionIndex];
      });
      syncVariant(variant);
      selects.forEach(function(select){select.dispatchEvent(new Event('change',{bubbles:true}))});
      syncVariant(variant);
      if(swatch.dataset.colourImage)setHero(swatch.dataset.colourImage,(swatch.dataset.value||actual)+' '+(hero.alt||''),'');
      changing=false;
    }

    function buildMobilePicker(){
      var gallery=root.querySelector('.lmu-pdp-v10__gallery');
      if(!gallery||!originalSwatches.length)return;
      var existing=root.querySelector('.lmu-mobile-colour-picker');
      if(existing)existing.remove();

      var picker=document.createElement('section');
      picker.className='lmu-mobile-colour-picker';
      picker.setAttribute('aria-label','Choose colour');

      var heading=document.createElement('div');
      heading.className='lmu-mobile-colour-picker__heading';
      heading.innerHTML='<strong>Colour</strong><span data-mobile-selected-colour></span>';
      picker.appendChild(heading);

      var grid=document.createElement('div');
      grid.className='lmu-mobile-colour-picker__grid';
      originalSwatches.forEach(function(original){
        var clone=original.cloneNode(true);
        clone.classList.add('lmu-mobile-colour-picker__button');
        grid.appendChild(clone);
      });
      picker.appendChild(grid);
      gallery.appendChild(picker);

      var colourSelect=form.querySelector('select[data-option-index="'+colourIndex+'"]');
      if(colourSelect){
        var label=picker.querySelector('[data-mobile-selected-colour]');
        if(label)label.textContent=colourSelect.value;
      }
    }

    document.addEventListener('click',function(event){
      var swatch=event.target.closest&&event.target.closest('.lmu-pdp-v10 [data-colour-swatch]');
      if(!swatch||!root.contains(swatch))return;
      event.preventDefault();
      event.stopImmediatePropagation();
      customerChangedMedia=true;
      chooseColour(swatch);
      var mobileLabel=root.querySelector('[data-mobile-selected-colour]');
      if(mobileLabel)mobileLabel.textContent=swatch.dataset.value||'';
    },true);

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click',function(){
        customerChangedMedia=true;
        resetZoom();
        var src=thumb.dataset.image||'';
        if(src)setHero(src,thumb.dataset.alt||'',thumb.dataset.imageId||'');
      },true);
    });

    selects.forEach(function(select){
      select.addEventListener('change',function(event){
        if(changing)return;
        if(event&&event.isTrusted)customerChangedMedia=true;
        var variant=findVariant(currentValues());
        if(variant)syncVariant(variant);
      });
    });

    /* Canonical colour selector is already positioned below the gallery on all viewports. */
    initHoverZoom();
    var initial=findVariant(currentValues());
    if(initial)syncVariant(initial,false);
    restoreOpeningHero();

    if(document.readyState==='complete'){
      scheduleOpeningHeroRestore();
    }else{
      document.addEventListener('DOMContentLoaded',scheduleOpeningHeroRestore,{once:true});
      window.addEventListener('load',function(){setTimeout(restoreOpeningHero,0);setTimeout(restoreOpeningHero,150);setTimeout(restoreOpeningHero,500)},{once:true});
    }
  }

  function boot(){document.querySelectorAll('.lmu-pdp-v10').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('load',boot,{once:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(boot,0)});
})();
